// TranslateApi facade — POST /api/translate cagrisini sarip Vue bilesenleri
// icin sade bir async API sunar. CommonVueCore PointHttpClientService donen
// `response` objesinin .data.Data icinde TranslateResponse olur, .data.Message
// ise CoreXBusinessException ile firlatilan kodu (orn. PROVIDER_REJECTED)
// tasir; ikisini de saran kucuk bir result objesi donduruyoruz.

export class TranslateApiService {
    /**
     * @param {Object} args
     * @param {Object} args.client          Provide edilen TranslateApi service client
     * @param {string} args.text            Cevrilecek metin
     * @param {string} args.sourceLanguage  ISO 639-1 (orn "tr") veya "auto"
     * @param {string} args.targetLanguage  ISO 639-1 (orn "en")
     * @param {string} [args.provider]      Opsiyonel — "GoogleTranslate" | "MyMemory" | ...
     * @returns {Promise<{ ok: boolean, translatedText?: string, sourceLanguage?: string, targetLanguage?: string, providerName?: string, confidence?: number, errorCode?: string, errorMessage?: string }>}
     */
    async translate({ client, text, sourceLanguage, targetLanguage, provider = null }) {
        const response = await client.post({
            route: "/api/translate",
            data: {
                Text: text,
                SourceLanguage: sourceLanguage,
                TargetLanguage: targetLanguage,
                Provider: provider || undefined,
            },
            headers: { "Content-Type": "application/json" },
        });

        const body = response?.data;

        // CoreXResponse.ResponseCode enum: "Success" / "Fail" / "Validation" / "NotFound" /
        // "Unauthorized" / "Info" / "Warn". Basari kosulu: code "Success" VE Data var.
        const isSuccess = body?.ResponseCode === "Success" && body?.Data;

        if (isSuccess) {
            return {
                ok: true,
                translatedText: body.Data.TranslatedText,
                sourceLanguage: body.Data.SourceLanguage,
                targetLanguage: body.Data.TargetLanguage,
                providerName: body.Data.ProviderName,
                confidence: body.Data.Confidence,
            };
        }

        return {
            ok: false,
            errorCode: body?.Message
                || response?.ResponseErrorCode
                || response?.ResponseStatus?.ErrorCode
                || "UNKNOWN",
            errorMessage: body?.ErrorMessages?.[0]
                || response?.ResponseMessage
                || response?.ResponseStatus?.Message
                || "Translation request failed",
        };
    }
}
